// "Is it right for you?": a blue intro panel beside the three statements that describe a good fit.
import { Layers, ListChecks, Workflow } from "lucide-react";
import { Button } from "../common/ui";

const items = [
  {
    icon: Workflow,
    label: "Automation",
    text: "You want to automate repetitive tasks, streamline workflows and free your team from manual work so they can focus on higher-value activities.",
  },
  {
    icon: ListChecks,
    label: "Coverage & reporting",
    text: "You want thorough test coverage, detailed scenarios and strong reporting, so the quality of your applications stays at the highest level.",
  },
  {
    icon: Layers,
    label: "All-in-one testing",
    text: "You want performance, security and code testing in the same place as your test management, with AI to speed up the work.",
  },
];

export default function WhyFit() {
  return (
    <div className="why-fit">
      <div className="why-fit__panel">
        <span className="why-fit__eyebrow">Is it right for you?</span>
        <h2 className="why-fit__title">
          Is Froth TestOps the right tool for <span>your organization?</span>
        </h2>
        <p className="why-fit__lead">It probably is, if any of these sound familiar.</p>
        <Button to="/contact" variant="light" icon>
          Talk to Us
        </Button>
      </div>

      <ul className="why-fit__list">
        {items.map(({ icon: Icon, label, text }, i) => (
          <li key={label} className="why-fit__item">
            <span className="why-fit__icon">
              <Icon size={20} aria-hidden="true" />
            </span>
            <span className="why-fit__body">
              <span className="why-fit__label">
                <span className="why-fit__num">0{i + 1}</span>
                {label}
              </span>
              <span className="why-fit__text">{text}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
